export enum UserRole {
  ADMIN = 'admin',
  STUDENT = 'student',
  TEACHER = 'teacher',
  COMPANY_CLIENT = 'companyClient',
  DIRECTOR = 'director',
  RESPONSIBLE = 'responsible',
  OPERATOR = 'operator'
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.STUDENT]: 'Alumno',
  [UserRole.TEACHER]: 'Profesor',
  [UserRole.COMPANY_CLIENT]: 'Cliente Empresa',
  [UserRole.DIRECTOR]: 'Director',
  [UserRole.RESPONSIBLE]: 'Responsable',
  [UserRole.OPERATOR]: 'Operadora'
};
